module.exports = __webpack_public_path__ + "img/about-health.f706d131.jpeg";